const SORT_OPTIONS = [
  { value: "", label: "おすすめ順" },
  { value: "newest", label: "新着順" },
  { value: "upcoming", label: "活動日が近い順" },
];

// NOTE: 現状名古屋でしか使わないため、バックエンドから渡さずフロント定数にしている（value は Area マスタの ID）
// NOTE: 「名古屋市」は区の一括選択ではなく名古屋市自体のIDで検索し、区が付いていない募集も対象にする
//       （Company::Config::Filters::NagoyaFilter::NAGOYA_AREA_ID と同じ値）
export const NAGOYA_CITY_OPTION = { value: "272", label: "名古屋市" };

export const NAGOYA_WARD_OPTIONS = [
  { value: "1568", label: "千種区" },
  { value: "1572", label: "守山区" },
  { value: "1574", label: "東区" },
  { value: "1578", label: "緑区" },
  { value: "1567", label: "北区" },
  { value: "1570", label: "名東区" },
  { value: "1579", label: "西区" },
  { value: "1571", label: "天白区" },
  { value: "1566", label: "中村区" },
  { value: "1564", label: "中区" },
  { value: "1573", label: "昭和区" },
  { value: "1577", label: "瑞穂区" },
  { value: "1576", label: "熱田区" },
  { value: "1565", label: "中川区" },
  { value: "1575", label: "港区" },
  { value: "1569", label: "南区" },
];

export default SORT_OPTIONS;
